import { useState } from 'react';
import { ButtonLoading, Icons } from 'components';
import createToast from 'components/Toast/Toast';
import { createSanitizeHtml } from 'utility';
import {
  Grid,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  CircularProgress,
} from '@mui/material';
import { useEffect } from 'react';
import Services from './Services';
import { useStyles } from './style';
import SendEmailDg from './SendEmailDg';
import { getDynamicObjectAction } from 'utility';
import { useNavigate } from 'react-router-dom';
import { useCurrencyUnit } from 'hooks';

const TransactionReceiptDg = (props) => {
  const {
    documentId,
    documentItemId,
    isOpenTransactionReceipt,
    setIsOpenTransactionReceipt,
    isReporty = false,
    redirectUrl,
    isReportyType,
  } = props;
  const [htmlData, setHtmlData] = useState('');
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [isOpenSendDg, setIsOpenSendDg] = useState(false);
  const [isSubmitingEmail, setIsSubmitingEmail] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);

  useEffect(() => {
    isOpenTransactionReceipt && getHtmlData();
    !isOpenTransactionReceipt && resetData();
  }, [isOpenTransactionReceipt]);

  const actionsList = getDynamicObjectAction([
    'transactionReceiptShareReciveActionList',
    'transactionReceipPdftReciveActionList',
    'reportShareGuildBtn',
    'reportPdfGuildBtn',
    'branchTransactionPage',
    'imprestTransactionPage',
    'accountTransactionsGuildPage',
  ]);

  /**
   * دریافت html رسید تراکنش از سرویس
   */
  const getHtmlData = () => {
    setIsLoading(true);
    let params = { documentItemId: documentItemId };
    const headers = { idToken: 'true' };
    const request = isReporty
      ? isReportyType === 'imprest'
        ? Services.financialTransctionReciptReportHtml(documentId)
        : Services.financialTransctionReciptReportSettlmentHtml(documentId)
      : Services.financialTransctionReciptHtml(documentId, params, headers);

    request
      .then((res) => {
        const str = String(res?.result)
          .replace('7.5in', 'none')
          .replace(
            /width: 2.5in !important; min-width: 2.5in !important;/g,
            'width: 60% !important; min-width: 60% !important;padding-right: 0.1in;',
          )
          .replace(
            /width: 2in !important; min-width: 2in !important;/g,
            'width: 40% !important; min-width: 40% !important; text-align:right',
          )
          .replace('padding-left:3in;', '')
          .replace('padding-left: 3in;', '')
          .replace(/0.8rem;/g, '0.8rem;font-weight:bold;');

        setHtmlData(str);

        setTimeout(() => {
          generateDom();
        }, 10);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
      });
  };

  /**
   * دانلود pdf رسید تراکنش
   */
  const onDownloadPdf = async () => {
    try {
      setIsLoadingPdf(true);
      let params = { documentItemId: documentItemId };
      isReporty
        ? await (isReportyType === 'imprest'
            ? Services.financialTransctionReciptReportyPdf(documentId)
            : Services.financialTransctionReciptSettlmentPdf(documentId))
        : await Services.financialTransctionReciptPdf(documentId, params);
    } catch (error) {
      setIsLoadingPdf(false);
    } finally {
      setIsLoadingPdf(false);
    }
  };

  const resetData = () => {
    setTimeout(() => {
      setIsError(false);
      setHtmlData('');
    }, 500);
  };

  const generateDom = () => {
    const t = document.querySelectorAll('.table');
    t.forEach((box) => {
      box.classList.add(classes.myCustomTable);
    });
    const r = document.querySelectorAll('.table-Rows');
    for (const item of r) {
      if (String(item.textContent).includes(currencyText)) {
        item.style.direction = 'rtl';
      }
    }
    setIsLoading(false);
  };
  /**
   * ارسال  و اشتراک گذاری به ایمیل
   */
  const onSendEmail = (emails) => {
    setIsSubmitingEmail(true);
    const obj = {
      emails: [...emails],
      transactionReceiptDto: {
        documentItemId: documentItemId,
      },
    };
    Services.shareWithEmail(documentId, obj)
      .then(() => {
        setIsOpenSendDg(false);
        createToast('موفق', 'اشتراک گذاری با موفقیت انجام شد.', 'success');
      })
      .catch((error) => {})
      .finally((f) => {
        setIsSubmitingEmail(false);
      });
  };
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      fullWidth
      maxWidth="sm"
      open={isOpenTransactionReceipt}
      className={classes.dialogMain}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={!isReporty ? () => setIsOpenTransactionReceipt(false) : false}
        className={classes.dialogTitle}
      >
        رسید تراکنش
        {!isReporty && (isError || !isLoading) && (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setIsOpenTransactionReceipt(false)}
            size="large">
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        {!isError && (
          <div
            style={{
              visibility: htmlData && !isLoading ? 'visible' : 'hidden',
              position: isLoading ? 'absolute' : 'static',
            }}
          >
            <Grid className={classes.actionButtons}>
              <Grid style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                <>
                  {(actionsList['transactionReceipPdftReciveActionList'] ||
                    actionsList['reportPdfGuildBtn'] ||
                    actionsList['branchTransactionPage'] ||
                    actionsList['imprestTransactionPage'] ||
                    actionsList['accountTransactionsGuildPage']) && (
                    <ButtonLoading
                      color="primary"
                      variant="outlined"
                      name={
                        <>
                          خروجی Pdf{' '}
                          <span style={{ marginRight: '5px', marginTop: '7px' }}>
                            <Icons icon="Archive" color="#2b3990" size="22" />
                          </span>
                        </>
                      }
                      loading={isLoadingPdf}
                      onClick={onDownloadPdf}
                      className={classes.buttonAction}
                    />
                  )}
                  {isReporty && (
                    <ButtonLoading
                      color="primary"
                      variant="outlined"
                      name={
                        <>
                          بستن
                          <span style={{ marginRight: '5px', marginTop: '7px' }}>
                            <Icons
                              icon="CloseCircle"
                              color="#2b3990"
                              size="20"
                              style={{ marginRight: '5px' }}
                            />
                          </span>
                        </>
                      }
                      onClick={() => {
                        navigate(redirectUrl);
                        scroll.scrollToTop();
                      }}
                      className={classes.buttonAction}
                    />
                  )}
                  {!isReporty &&
                    (actionsList['transactionReceiptShareReciveActionList'] ||
                      actionsList['reportShareGuildBtn'] ||
                      actionsList['imprestTransactionPage'] ||
                      actionsList['accountTransactionsGuildPage'] ||
                      actionsList['branchTransactionPage']) && (
                      <ButtonLoading
                        color="primary"
                        variant="outlined"
                        name={
                          <>
                            اشتراک گذاری{' '}
                            <span style={{ marginRight: '5px', marginTop: '7px' }}>
                              <Icons
                                icon="mail"
                                color="#2b3990"
                                size="20"
                                style={{ marginRight: '5px' }}
                              />
                            </span>
                          </>
                        }
                        onClick={(e) => {
                          setIsOpenSendDg(true);
                        }}
                        className={classes.buttonAction}
                      />
                    )}
                </>
              </Grid>
            </Grid>
            <Grid id="myDialogId" className={classes.boxTabel} style={{ paddingRight: '8px' }}>
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: createSanitizeHtml(htmlData) }}
              ></div>
            </Grid>
          </div>
        )}

        {isLoading && (
          <div className={classes.isLoading}>
            <CircularProgress size={24} />
          </div>
        )}
        {isError && isLoading == false && (
          <>
            <div className={classes.isError}>امکان دریافت رسید برای این نوع تراکنش وجود ندارد.</div>
            {isReporty && (
              <ButtonLoading
                color="primary"
                variant="contained"
                style={{  marginTop: '20px' , width: '85%' }}
                name={
                  <>
                    بستن
                    <span style={{ marginRight: '5px', marginTop: '7px' }}>
                      <Icons
                        icon="CloseCircle"
                        color="#fff"
                        size="22"
                      />
                    </span>
                  </>
                }
                onClick={() => {
                 setIsOpenTransactionReceipt(false);
                }}
                className={classes.buttonAction}
              />
            )}
          </>
        )}
      </DialogContent>
      <SendEmailDg
        open={isOpenSendDg}
        setOpen={setIsOpenSendDg}
        onSendEmail={onSendEmail}
        isSubmitingEmail={isSubmitingEmail}
      />
    </Dialog>
  );
};

export default TransactionReceiptDg;
